import Vue from 'vue';
import OfsMenu from '@oneflow/ofs-vue-layout';
import BootstrapVue from 'bootstrap-vue';
import '@oneflow/ofs-vue-layout/dist/index.css';
import store, { i18n } from './vuex';
import router, { menuStructure } from './router';
import App from './App';
import './registerServiceWorker';

Vue.config.productionTip = false;
Vue.use(OfsMenu, { router, store, menu: menuStructure });
Vue.use(BootstrapVue);

/* eslint-disable no-new */
new Vue({
	i18n,
	el: '#app',
	router,
	store,
	template: '<App/>',
	components: { App }
});
